import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";

function TippingDashboard() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [IsPorter, setIsPorter] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [MNVMoverTipAmountID, setMNVMoverTipAmountID] = useState(0);
  const [tippingObject, setTippingObject] = useState({
    EndDate: getEndOfMonth(),
    JobID: "",
    MNVMoverID: 0,
    StartDate: getStartOfMonth(),
    EarningsView: true,
    Total: 0,
  });

  const [movers, setMovers] = useState<any>([]);
  const [moversData, setMoversData] = useState<any>([]);
  const [gridData, setGridData] = useState<any>([]);

  useEffect(() => {
    ClearFilters(false);
    setIsPorter(globalState.IsPorter);
    getDriverJobsWithTipping();
  }, [clearFilters]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();

    setTippingObject((prevState: any) => ({
      ...prevState,
      StartDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth(),
        1,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      EndDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() + 1,
        0,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      JobID: "",
      MNVMoverID: 0,
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getDriverJobsWithTipping() {
    setIsAnimation(true);
    let object = tippingObject;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/MNVQuoteGetDriverJobsWithTipping",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;

          let Total = 0;
          for (var i = 0; i < l_response[0].length; i++) {
            Total += l_response[0][i]["Amount"];
          }
          if (IsPorter) tippingObject.MNVMoverID = globalState.MNVMoverID;

          setGridData(l_response[0]);
          setMovers(l_response[1]);
          setMoversData(l_response[3]);

          setTippingObject((prevState: any) => ({
            ...prevState,
            Total: Total,
          }));
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const MNVQuoteSplitAgencyTipIntoMainTeam = async () => {
    const data = {} as any;
    data.MNVMoverTipAmountID = MNVMoverTipAmountID;
    data.MNVMoverIDs = GetSelectedIDsFromList("tippingMover");

    setIsAnimation(true);

    try {
      await axiosAuth.post(
        AppContext.APIURL +
        "api/MNVQuoteAdmin/MNVQuoteSplitAgencyTipIntoMainTeam",
        data
      );

      setShowModal(false);
      setIsAnimation(false);
      getDriverJobsWithTipping();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-btw flex-gap10">
              <div className="flex-da flex-gap10 date-field">
                <div className="field-input">
                  <input
                    type="date"
                    title="Service Start Date"
                    placeholder="Lag"
                    value={tippingObject.StartDate}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        StartDate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                <div className="field-input date-field">
                  <input
                    type="date"
                    title="Service End Date"
                    placeholder="Lag"
                    value={tippingObject.EndDate}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        EndDate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                {!IsPorter && (
                  <div className="field-input">
                    <select
                      className="input-field"
                      value={tippingObject.MNVMoverID}
                      onChange={(e) =>
                        setTippingObject((prevState: any) => ({
                          ...prevState,
                          MNVMoverID: e.target.value,
                        }))
                      }
                    >
                      <option value={0}>Select Contractor</option>
                      {movers &&
                        movers.map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                )}

                <div className="data-boxes">
                  <span>
                    Total: £
                    {tippingObject.Total.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                <div className="flex-daj btn-start flex-gap10">
                  <a
                    onClick={() => ClearFilters(true)}
                    className="btn-primary flex-daj"
                  >
                    Clear Filters
                  </a>
                  <a
                    onClick={() => getDriverJobsWithTipping()}
                    className="btn-primary flex-daj"
                  >
                    Filter
                  </a>
                </div>
              </div>

              <div className="flex-d btn-start flex-gap10">
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblmarketingscore",
                      "Tipping Dashboard"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flow-auto mt-10">
              <table className="reuse-table" id="tblmarketingscore">
                <thead>
                  <tr>
                    <th>Date</th>
                    {!IsPorter && <th>Contractor Name</th>}
                    <th>Role</th>
                    <th>Job ID</th>
                    <th>Total Amount </th>
                    {!IsPorter && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {gridData &&
                    gridData.map((Item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>{formateDate(Item.RequestedDate)}</td>
                          {!IsPorter && <td>{Item.MNVMoverName}</td>}
                          <td>{Item.RoleID == 1 ? "Driver" : "Helper"}</td>
                          <td>{Item.JobID}</td>
                          {/* <td>{Item.Amount}</td> */}
                          <td className="text-right">
                            £
                            {Number(Item.Amount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>

                          {!IsPorter && (
                            <td className="text-center">
                              <div className="flex-daj gap-10">
                                {Item.CanSplitAmount == 1 && (
                                  <a
                                    onClick={() => {
                                      setMNVMoverTipAmountID(
                                        Item.MNVMoverTipAmountID
                                      );
                                      setShowModal(true);
                                    }}
                                  >
                                    <img
                                      src="images/split.svg"
                                      width="18px"
                                      height="18px"
                                      alt="split"
                                      className="invert-icon"
                                    />
                                  </a>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </>
      )}

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Split</h3>
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d flex-gap15 mt-20 font-mont">
                <>
                  {moversData?.map((data: any) => (
                    <div
                      key={data.MNVMoverID}
                      className="flex-da font-12 flex-gap10"
                    >
                      <input
                        type="checkbox"
                        value={data.MNVMoverID}
                        name="tippingMover"
                      />
                      <span>{data.Name}</span>
                    </div>
                  ))}
                  <span className="bold-font font-13 flex-daj">
                    Are you sure you want to split this amount?
                  </span>
                </>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => MNVQuoteSplitAgencyTipIntoMainTeam()}
                  >
                    Yes, Do It
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TippingDashboard;
